import { Box, Button, Card, Chip, Divider, Stack, Typography, useTheme } from '@mui/material';
import downloadFile from 'utils/downloadFile';
import FormatDate from 'utils/formatDate';
import formatCurrency from 'utils/formatCurrency';

const HotelInvoiceItem = ({ invoice }) => {
    const theme = useTheme();

    const handleDownload = async () => {
        if (!invoice?.id) return;
        
        await downloadFile(`/api/prv/member-invoices/download/${invoice.id}`);
    };

    return (
        <Card
            sx={{
                p: 2,
                borderRadius: 2,
                boxShadow: '0 6px 24px rgba(0,0,0,0.08)',
                border: `1px solid ${theme.palette.divider}`,
            }}
        >
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Stack spacing={0.25}>
                    <Typography variant="subtitle2" color="text.secondary">
                        Invoice
                    </Typography>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Typography variant="h6" fontWeight={700}>
                            {invoice?.number || '-'}
                        </Typography>
                        <Chip
                            size="small"
                            label="Paid"
                            color="success"
                            sx={{ fontWeight: 700 }}
                        />
                    </Stack>
                </Stack>
                <Button variant="outlined" onClick={handleDownload}>
                    Download Reservation Invoice
                </Button>
            </Stack>

            <Divider sx={{ my: 1.5 }} />

            <Box>
                <Stack spacing={0.5}>
                    <Typography>
                        Room Type: {invoice?.reservation?.roomType?.name || '-'}
                    </Typography>
                    <Typography>
                        Check-in:{' '}
                        {FormatDate(invoice?.reservation?.checkIn?._date, 'dd MMM yyyy')}
                    </Typography>
                    <Typography>
                        Check-out:{' '}
                        {FormatDate(invoice?.reservation?.checkOut?._date, 'dd MMM yyyy')}
                    </Typography>
                    <Typography>Nights: {invoice?.reservation?.nights || 0}</Typography>
                    <Typography fontWeight={700}>
                        Total: {formatCurrency(invoice?.totalPrice || 0)}
                    </Typography>
                </Stack>
            </Box>
        </Card>
    );
};

export default HotelInvoiceItem;
